import { render, staticRenderFns } from "./EventosStream.vue?vue&type=template&id=2b255980&scoped=true&"
import script from "./EventosStream.vue?vue&type=script&lang=js&"
export * from "./EventosStream.vue?vue&type=script&lang=js&"
import style0 from "./EventosStream.vue?vue&type=style&index=0&id=2b255980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b255980",
  null
  
)

export default component.exports